export const requiredMetadataKey = Symbol('required');
export const defaultValueMetadataKey = Symbol('defaultValue');
export const arrayItemTypeMetadataKey = Symbol('arrayItemType');
export const enumTypeMetadataKey = Symbol('enumType');
export const classMetadataKey = Symbol('classMetadata');

export function ClassMetadata(target: any) {
    const properties = Object.getOwnPropertyNames(new target());

    properties.forEach(property => undefined);
}

export function Required(target: any, propertyKey: string) {
    // Intentionally left empty for metadata purposes
}

export function Unrequired(target: any, propertyKey: string) {
    // Intentionally left empty for metadata purposes
}

export function DefaultValue(value: any) {
    return function (target: any, propertyKey: string) {
        // Intentionally left empty for metadata purposes
    };
}

export function Description(value: any) {
    return function (target: any, propertyKey: string) {
        // Intentionally left empty for metadata purposes
    };
}


export function ArrayItemType(itemType: any) {
    return function (target: any, propertyKey: string) {
        // Intentionally left empty for metadata purposes
    };
}

export function EnumType(enumType: any) {
    return function (target: any, propertyKey: string) {
        // Intentionally left empty for metadata purposes
    };
}

export function isRequired(target: any, propertyKey: string): boolean {
    return true
}

export function getDefaultValue(target: any, propertyKey: string): any {
    // Intentionally left empty for metadata purposes
}

export function getType(target: any, propertyKey: string): any {
    // Intentionally left empty for metadata purposes
}

export function getArrayItemType(target: any, propertyKey: string): any {
    // Intentionally left empty for metadata purposes
}

export function getEnumValues(target: any, propertyKey: string): any[] {
    return []
}
